import styled from 'styled-components';
import Heading from '../Heading';
const H3 = styled(Heading).attrs({
  tagName: 'h3'
}).withConfig({
  displayName: "H3"
})([""]);
H3.displayName = 'H3';
export default H3;